import { InformationCircleIcon } from '@heroicons/react/24/solid';
import { Tooltip } from '@kira/checkpoint-shared-frontend';
import React from 'react';
import { twMerge } from 'tailwind-merge';

interface LabelWithTooltipProps {
  label: string;
  tooltipText: string;
}

const LabelWithTooltip = ({ label, tooltipText }: LabelWithTooltipProps) => {
  const labelClassName = twMerge('font-roboto', 'text-sm', 'text-slate-500');

  const informationCircleClassName = twMerge(
    'ml-1',
    'inline-block',
    'h-3',
    'w-3',
    'text-kira-slate-700'
  );

  const tooltipContainerClassName = twMerge('z-50');

  const tooltipTextClassName = twMerge('text-left', 'whitespace-pre-line');

  return (
    <div className="flex items-center">
      <p className={labelClassName}>{label}</p>
      <Tooltip
        textContent={tooltipText}
        tooltipClassNames={tooltipContainerClassName}
        textClassNames={tooltipTextClassName}
      >
        <InformationCircleIcon className={informationCircleClassName} />
      </Tooltip>
    </div>
  );
};

export default LabelWithTooltip;
